// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"76e5f27f","238":"48228b13","496":"a0983616","526":"b7a54e30","640":"9e4a8a51","678":"aa781121","856":"b73e70f1"}[chunkId] + ".chunk.js";
};